module.exports = __webpack_public_path__ + "img/CattleyaoneHandedSword_04.b9f1ed5a.png";